module.exports = __webpack_public_path__ + "img/768_stores_img7.2b7ebe17.png";